import { useMutation, UseMutationResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { formatResponse } from "../../utils/FormatUtils";

export function useEditMedicalFillInFormVitalMutation(): UseMutationResult<unknown, Error> {
  return useMutation((x) =>
    httpClient.put(ApiRoutes.patientVitalTransactionItem, { data: x }).then(formatResponse),
  );
}
